/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 * - successful theme add-to-cart events: continue to the full cart page.
 */

let cartRedirectPending = false;

document.addEventListener('shopify:cart:lines-update', (event) => {
  if (event.action !== 'add' || !event.promise || cartRedirectPending) return;

  event.promise
    .then((result) => {
      if (result?.detail?.didError || result?.userErrors?.length) return;

      cartRedirectPending = true;

      // Allow the completed add-to-cart event and its analytics listeners to
      // finish before starting the cart-page navigation.
      setTimeout(() => {
        window.location.assign(Theme.routes.cart_url || '/cart');
      }, 0);
    })
    .catch(() => {
      // Product-form and cart-error components retain responsibility for
      // presenting failures without navigating away from the current page.
    });
});

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
